import { useTranslation } from "react-i18next";

export interface Column<T> {
  key: string;
  header: string;
  render: (row: T) => React.ReactNode;
}

interface DataTableProps<T> {
  rows: T[];
  columns: Column<T>[];
  loading?: boolean;
  error?: string | null;
  emptyMessage?: string;
}

export default function DataTable<T>({
  rows,
  columns,
  loading,
  error,
  emptyMessage,
}: DataTableProps<T>) {
  const { t } = useTranslation();

  if (loading) return <div className="text-secondary" style={{ padding: 24 }}>{t("common.loading")}</div>;
  if (error) return <div style={{ color: "var(--red)", padding: 16 }}>{error}</div>;

  return (
    <div style={{ overflowX: "auto" }}>
      <table>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key}>{c.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center", color: "var(--muted)" }}>
                {emptyMessage ?? t("common.noResults")}
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr key={i}>
                {columns.map((c) => (
                  <td key={c.key}>{c.render(row)}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
